import { render, staticRenderFns } from "./FooterCustom.vue?vue&type=template&id=1ba0c4b5&scoped=true"
var script = {}
import style0 from "./FooterCustom.vue?vue&type=style&index=0&id=1ba0c4b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba0c4b5",
  null
  
)

export default component.exports